import React, { Component } from 'react';
import './style.css';
import { Route, Switch } from 'react-router-dom';
import Comparison from './comparison';
import Term from './term';
import Opposite from './opposite';

class Pair extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: props.pair.answer.term,
      opposite: props.pair.answer.opposite
    };
    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.saveTerm = this.saveTerm.bind(this);
    this.saveOpposite = this.saveOpposite.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  save(singleAspect) {
    if (singleAspect.answer.term && singleAspect.answer.opposite) {
      this.props.save(singleAspect, this.props.pair.pairId);
    }
  }

  saveTerm(value) {
    this.setState({ term: value });
    let singleAspect = {
      answer: {
        term: value,
        opposite: this.state.opposite
      }
    };
    this.save(singleAspect);
  }

  saveOpposite(value) {
    this.setState({ opposite: value });
    let singleAspect = {
      answer: {
        term: this.state.term,
        opposite: value
      }
    };
    this.save(singleAspect);
  }

  render() {
    const props = this.props;
    const url = this.props.project + '/pair/' + this.props.pair.pairId;
    return (
      <Switch>
        <Route
          path={url}
          exact
          render={() => (
            <Comparison pair={props.pair} url={url} skip={props.skip} />
          )}
        />
        <Route
          path={url + '/' + props.pair.projectObjects[0].uuid}
          exact
          render={() => (
            <Term
              pair={props.pair}
              projectObject={props.pair.projectObjects[0]}
              save={this.saveTerm}
              url={url}
              skip={props.skip}
              maxLength="50"
            />
          )}
        />

        <Route
          path={url + '/' + props.pair.projectObjects[1].uuid}
          exact
          render={() => (
            <Term
              pair={props.pair}
              projectObject={props.pair.projectObjects[1]}
              save={this.saveTerm}
              url={url}
              skip={props.skip}
              maxLength="50"
            />
          )}
        />

        <Route
          path={url + '/opposite'}
          exact
          render={() => (
            <Opposite
              term={this.state.term}
              save={this.saveOpposite}
              url={props.project}
              skip={props.skip}
              pair={props.pair}
              maxLength="50"
            />
          )}
        />
      </Switch>
    );
  }
}

export default Pair;



// WEBPACK FOOTER //
// ./src/preference/components/Pair/index.js